import styled from "styled-components";

export const StyledSun = styled.svg`
    height: auto;
    width: 2.5rem;
    transition: all 0.7s linear;
`;
